import { render, staticRenderFns } from "./StpAccountDuplicated.vue?vue&type=template&id=789d29f7&scoped=true&"
import script from "./StpAccountDuplicated.vue?vue&type=script&lang=js&"
export * from "./StpAccountDuplicated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789d29f7",
  null
  
)

export default component.exports